/**
 * Base64 Encoding/Decoding implementation
 * Converts text to/from Base64 format
 */

export const base64Encrypt = (text) => {
  try {
    return btoa(unescape(encodeURIComponent(text)));
  } catch (error) {
    throw new Error('Failed to encode to Base64: ' + error.message);
  }
};

export const base64Decrypt = (text) => {
  try {
    return decodeURIComponent(escape(atob(text)));
  } catch (error) {
    throw new Error('Failed to decode from Base64: ' + error.message);
  }
};

export const base64Cipher = {
  name: 'Base64',
  encrypt: base64Encrypt,
  decrypt: base64Decrypt,
  requiresKey: false,
  description: 'Encodes text using Base64 encoding'
};
